export default __webpack_public_path__ + "static/media/productblue.5e99756d.svg";